/* import __COLOCATED_TEMPLATE__ from './settings.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();